import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  children, 
  ...props 
}) => {
  const baseStyles = "inline-flex items-center justify-center rounded-2xl font-bold transition-all duration-300 focus:outline-none focus:ring-4 disabled:opacity-50 disabled:cursor-not-allowed active:scale-95";
  
  const variants = {
    // E-Ambulante Green (#00C853)
    primary: "bg-brand-green text-white hover:bg-brand-green-dark shadow-xl shadow-brand-green/20 hover:shadow-brand-green/30 hover:-translate-y-0.5 focus:ring-brand-green/20",
    
    // E-Ambulante Orange (#FF6D00)
    secondary: "bg-brand-orange text-white hover:bg-brand-orange-dark shadow-xl shadow-brand-orange/20 hover:shadow-brand-orange/30 hover:-translate-y-0.5 focus:ring-brand-orange/20",
    
    outline: "bg-white border-2 border-slate-200 text-slate-700 hover:border-brand-green hover:text-brand-green hover:shadow-lg focus:ring-slate-100",
    
    ghost: "text-slate-600 hover:bg-slate-100 hover:text-slate-900",
  };

  const sizes = {
    sm: "px-4 py-2 text-xs",
    md: "px-6 py-3 text-sm",
    lg: "px-8 py-4 text-base",
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};